export const LOCAL_STORAGE_ROUTE_REFERRER = 'route_referrer';
